import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const ChatWithUs = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <a 
                href="https://wa.me/7796010086" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', fontSize: '24px', textDecoration: 'none', color: 'green' }}
            >
                <FaWhatsapp style={{ marginRight: '8px' }} />
                Chat with us
            </a>
        </div>
    );
};

export default ChatWithUs;
